module.exports = __webpack_public_path__ + "img/main-profile-icon2.aa8497ca.svg";